import { useState } from "react"
import { createFileRoute, Link } from "@tanstack/react-router"
import { auth } from "@/lib/auth"
import { Button, Input, Spinner, Toast } from "@/components/ui"

export const Route = createFileRoute("/forgot")({
  component: ForgotPage,
})

function ForgotPage() {
  const [email, setEmail] = useState("")
  const [done, setDone] = useState(false)
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    try {
      await auth.forgot(email)
      setDone(true)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="min-h-screen grid place-items-center px-4 bg-background">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm rounded-2xl border border-border bg-card/90 p-7 shadow-glass backdrop-blur space-y-4"
      >
        <div>
          <h1 className="text-xl font-semibold tracking-tight">Reset your password</h1>
          <p className="text-xs text-muted-foreground mt-1">
            We&rsquo;ll email a link if the address matches an account.
          </p>
        </div>
        <Input
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {done && (
          <Toast variant="ok">
            If an account exists, the email is on its way. Check your inbox.
          </Toast>
        )}
        <Button type="submit" disabled={busy || done} className="w-full">
          {busy ? <Spinner /> : null}
          Send reset link
        </Button>
        <p className="text-xs text-center text-muted-foreground">
          <Link to="/login" className="hover:text-foreground">Back to sign in</Link>
        </p>
      </form>
    </div>
  )
}
